import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FileZip.es.js";
const o = e.forwardRef((i, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...i, weights: a }));
o.displayName = "FileZipIcon";
const c = o;
export {
  c as FileZip,
  o as FileZipIcon
};
